<template>
  <div class="setting-component">
    <custom-scrollbar class="custom-scrollbar controller-scrollbar" @scroller-component="initScroll">
      <div class="form-group">
        <label class="form-label" for="once-label">
          {{ trans("live.tabs.settings.labels_tab.labels.once_label") }}
        </label>
        <custom-input v-model="settings.once_label" input-id="once-label" type="text" with-clear input-class="input" />
      </div>
      <div class="form-group form-group-near">
        <label class="form-label" for="once-message">
          {{ trans("live.tabs.settings.labels_tab.labels.once_message") }}
        </label>
        <custom-input
          v-model="settings.once_message"
          input-id="once-message"
          type="text"
          with-clear
          input-class="input" />
      </div>
      <div class="form-group">
        <label class="form-label" for="twice-label">
          {{ trans("live.tabs.settings.labels_tab.labels.twice_label") }}
        </label>
        <custom-input
          v-model="settings.twice_label"
          input-id="twice-label"
          type="text"
          with-clear
          input-class="input" />
      </div>
      <div class="form-group form-group-near">
        <label class="form-label" for="twice-message">
          {{ trans("live.tabs.settings.labels_tab.labels.twice_message") }}
        </label>
        <custom-input
          v-model="settings.twice_message"
          input-id="twice-message"
          type="text"
          with-clear
          input-class="input" />
      </div>
      <div class="form-group stage-b-item">
        <label class="form-label" for="next-lot-label">
          {{ trans("live.tabs.settings.labels_tab.labels.next_lot_label") }}
        </label>
        <custom-input
          v-model="settings.next_lot_label"
          input-id="next-lot-label"
          type="text"
          with-clear
          input-class="input" />
      </div>
      <div class="form-group form-group-near stage-b-item">
        <label class="form-label" for="next-lot-message">
          {{ trans("live.tabs.settings.labels_tab.labels.next_lot_message") }}
        </label>
        <custom-input
          v-model="settings.next_lot_message"
          input-id="next-lot-message"
          type="text"
          with-clear
          input-class="input" />
      </div>
      <div class="form-group stage-b-item">
        <label class="form-label" for="pass-lot-message">
          {{ trans("live.tabs.settings.labels_tab.labels.pass_lot_message") }}
        </label>
        <custom-input
          v-model="settings.pass_lot_message"
          input-id="pass-lot-message"
          type="text"
          with-clear
          input-class="input" />
      </div>
    </custom-scrollbar>
    <div class="action-block">
      <button class="btn btn-blue action" @click="save">
        {{ trans("live.tabs.settings.labels_tab.actions.save") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from "vue";

  import CustomInput from "@/components/_partials/widget/CustomInput.vue";
  import { trans } from "@/utils/trans";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { useToast } from "primevue/usetoast";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import simplebar from "simplebar-vue";
  const toast = useToast();
  const auctionStore = useAuctionStore();

  const settings = ref({
    once_label: auctionStore.liveSettings?.once_label,
    once_message: auctionStore.liveSettings?.once_message,
    twice_label: auctionStore.liveSettings?.twice_label,
    twice_message: auctionStore.liveSettings?.twice_message,
    next_lot_label: auctionStore.liveSettings?.next_lot_label,
    next_lot_message: auctionStore.liveSettings?.next_lot_message,
    pass_lot_message: auctionStore.liveSettings?.pass_lot_message
  });

  const scrollComponent = ref<typeof simplebar>(null);

  watch(
    () => auctionStore.liveSettings,
    (nv) => {
      settings.value.once_label = nv?.once_label;
      settings.value.once_message = nv?.once_message;
      settings.value.twice_label = nv?.twice_label;
      settings.value.twice_message = nv?.twice_message;
      settings.value.next_lot_label = nv?.next_lot_label;
      settings.value.next_lot_message = nv?.next_lot_message;
      settings.value.pass_lot_message = nv?.pass_lot_message;
    },
    { deep: true }
  );

  const initScroll = (scroll) => {
    scrollComponent.value = scroll;
  };

  const save = () => {
    apiClient
      .put(auctionStore.routes["auctions.update_live_settings"], settings.value)
      .then((response) => {
        if (response.data.status && response.data.settings) {
          auctionStore.$patch(response.data.settings);
        } else {
          console.log(response);
        }
        toast.add({
          severity: response.data.status ? "success" : "error",
          summary: trans("live.toast." + (response.data.status ? "success" : "error")),
          detail: response.data.message || trans("live.toast.unknown_error"),
          life: 6000
        });
      })
      .catch((error) => {
        console.log(error);
        const errors = error.response.data.errors;
        Object.keys(errors).forEach((key) => {
          errors[key].forEach((error: string) => {
            toast.add({
              severity: "error",
              summary: trans("live.toast.error"),
              detail: error || trans("live.toast.unknown_error"),
              life: 6000
            });
          });
        });
      });
  };
</script>
